import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-doctor2_diagnosis-enter-disease-neifenmi",
  "use": "icon-doctor2_diagnosis-enter-disease-neifenmi-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 22 22\" id=\"icon-doctor2_diagnosis-enter-disease-neifenmi\">\r\n  <g transform=\"translate(-1245 -518)\">\r\n    <path class=\"a\" d=\"M25.085,14.421a5.121,5.121,0,0,0,.57.542l-1.809,1.9a3.143,3.143,0,1,1-.57-.541Zm6.807.7,1.414,2.283a1.964,1.964,0,1,1-.668.414l-1.414-2.283a5.109,5.109,0,0,0,.668-.414Zm5.236-3.337a1.964,1.964,0,1,1-1.95,1.729l-1.592-.53a5.067,5.067,0,0,0,.248-.746l1.592.53A1.964,1.964,0,0,1,37.128,11.786Zm-8.25-5.107A4.322,4.322,0,1,1,24.556,11,4.322,4.322,0,0,1,28.878,6.679ZM21.806,2.357a2.357,2.357,0,0,1,2,3.608l1.528,1.359a5.153,5.153,0,0,0-.523.587L23.282,6.552a2.357,2.357,0,1,1-1.476-4.2ZM36.735,0a2.75,2.75,0,1,1-1.593,4.992L32.674,7.584a5.14,5.14,0,0,0-.569-.542L34.573,4.45A2.75,2.75,0,0,1,36.735,0Z\" transform=\"translate(1227.102 518)\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/doctor2_diagnosis-enter-disease-neifenmi.svg
// module id = bP48
// module chunks = 10